<template>
  <div class="wrapper box box_v">
    <!-- 头部标题 -->
    <page-head title="社区防疫" :btn-list="btnList" @handleBtn="handleBtn"></page-head>
    <div class="content box box_f1">
      <Card style="width: 100%">
        <div class="title1">
          基本信息
        </div>
        <CheckboxGroup v-model="group">
          <div class="item" v-for="(item, index) in inputList" :key="index">
            <Checkbox :label="index">&nbsp;</Checkbox>
            <Input
              :placeholder="item.fieldName? item.fieldName : '请输入'"
              :disabled="true"
              v-model="item.fieldName"
              class
              v-if="!item.type"
              style="width: 360px;"
            >{{item.fieldName}}</Input>
            <Select v-model="item.model" v-if="item.type == 'select'" style="width:360px">
              <Option
                v-for="_item in dictionaryBase"
                :value="_item.label"
                :key="_item.label"
              >{{ _item.label }}
              </Option>
            </Select>
          </div>
        </CheckboxGroup>
      </Card>
    </div>
  </div>
</template>

<script>
  import pageHead from '../../../components/head';

  export default {
    name: 'epidemicSet',
    components: {
      pageHead,
    },
    data() {
      return {
        btnList: [{
          name:'通知变更',
          type:'notice',
          loading: false
        },{
          name: '保存',
          type: 'fabu',
          loading: false,
        }],//头部按钮
        inputList: [],
        group:[]
      }
    },
    methods: {
      handleBtn(type, index) {
        if (type == 'fabu') {
          this.submitSetting()
        }
        if (type === 'notice') {
          this.publishNotice()
        }
      },
      getSettingList() {
        this.$get(this.urlobj.getEpidemicSetting).then(res => {
          this.inputList = res.rows
          res.rows.forEach((item, index) => {
            if (item.isShow) {
              this.group.push(index);
            }
          });
        })
      },
      publishNotice(){
        let url = this.urlobj.epidemicNotice
        this.btnList[0].loading = true
        this.$post(url).then(res=>{
          this.$Message.success('发布成功')
        }).finally(()=>{
          this.btnList[0].loading = false
        })
      },
      submitSetting () {
        var idList = []
        this.inputList.forEach((item, index) => {
          idList.push({
            id:item.id,
            isShow:this.group.indexOf(index)>-1?1:0
          })
        })
        this.btnList[1].loading = true
        this.$post(this.urlobj.changeEpidemicSetting,idList).then(res => {
          this.btnList[1].loading = false
          this.$Message.success('保存成功')
        }).catch(event => {
          this.btnList[1].loading = false
        })
      }
    },
    mounted() {
      this.getSettingList()
    }

  }
</script>

<style lang="less" scoped>
  .wrapper {
    color: #666666;
    overflow: hidden;
    height: 100%;
  }
  .newvote {
    position: absolute;
    right: 20px;
    button {
      width: 80px;
      height: 28px;
      line-height: 13px;
    }
    .btn-dc {
      background-color: #ff7c43;
      border-color: #ff7c43;
    }
  }

  .content {
    // max-width: 96%;
    margin: 0 20px 20px;
  }

  .item {
    // height: 40px;
    line-height: 32px;
    width: 48%;
    margin-bottom: 20px;
  }

  /deep/ .ivu-input {
    width: 360px;
    color: #333;
  }

  .add-con {
    font-size: 14px;
    color: #ff7b44;
    border: 1px solid #ff7b44;
    // width: 93px;
    display: inline-block;
    height: 26px;
    line-height: 26px;
    border-radius: 5px;
    // text-align: center;
    padding-left: 10px;
    padding-right: 10px;
  }

  .demo-spin-container {
    display: inline-block;
    width: 200px;
    height: 100px;
    position: relative;
  }

  .child {
    margin-left: 50px;
  }

  .title1 {
    font-size: 20px;
    margin-bottom: 20px;
    color: #333;
  }

  ._title {
    font-size: 16px;
    color: #999
  }

  .icon-shanchu {
    margin-left: 30px;
  }
</style>
